export default __webpack_public_path__ + "static/media/iread_22_7.000e763e.jpg";